export default (context) => {
  const apiKeyHeaders = process.env.VUE_APP_API_KEY ? {'x-api-key': process.env.VUE_APP_API_KEY} : {};
  const ssoToken = process.client ? sessionStorage.getItem('sis_customer_sso_token') : null;
  const authorizationHeaders = ssoToken ? {Authorization: `Bearer ${ssoToken}`} : {};

  return {
    httpEndpoint: process.env.VUE_APP_API_URL,
    httpLinkOptions: {
      headers: {
        ...apiKeyHeaders,
        ...authorizationHeaders,
      },
    },
    inMemoryCacheOptions: {
      addTypename: false,
    },
  }
}
